import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation } from '@tanstack/react-query'

type ProtocolType = 'landlord-handover' | 'landlord-return'

interface ProtocolPreviewParams {
  flatId: string
  protocolType: ProtocolType
}

export function useProtocolPreview() {
  const onError = useOnError()

  async function generateProtocol({ flatId, protocolType }: ProtocolPreviewParams) {
    if (!flatId) throw new Error('Flat ID is required')

    const res = await apiClient.get<Blob>(
      `${SNA_PREFIX}contracts/protocols/${protocolType}`,
      {
        params: { flat_id: flatId },
        responseType: 'blob'
      }
    )

    if (res.data.type === 'application/json') {
      const text = await res.data.text()
      const errorData = JSON.parse(text)
      throw errorData
    }

    return res.data
  }

  return useMutation({
    mutationFn: generateProtocol,
    onSuccess: (pdfBlob: Blob) => {
      const file = new Blob([pdfBlob], { type: 'application/pdf' })
      const fileURL = URL.createObjectURL(file)
      window.open(fileURL, '_blank')
      URL.revokeObjectURL(fileURL)
    },
    onError
  })
}
